import { useMutation } from '@apollo/client'
import { Input } from '@chain-zen/ui'
import { useState } from 'react'
import { toast } from 'sonner'

import { ASSIGN_SHIPMENT_TO_RELEASE } from '../../../../../data/mutations/shipment'

interface IReleaseInputProps {
  release: string | null
  shipmentID: string
}

/**
 * This component is used to input a release number for a shipment.
 */
export const ReleaseInput = ({ release, shipmentID }: IReleaseInputProps) => {
  const [inputRelease, setInputRelease] = useState<string | null>(release)

  const [assignShipmentToRelease] = useMutation(ASSIGN_SHIPMENT_TO_RELEASE, {
    onError: () => {
      toast.error('Failed to update shipment release:')
      setInputRelease(release)
    }
  })

  const handleReleaseChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputRelease(e.target.value)
  }

  const handleReleaseBlur = () => {
    // Only update if the value has changed
    if (inputRelease !== release) {
      assignShipmentToRelease({
        variables: {
          release: inputRelease === 'Add a release' ? null : inputRelease,
          shipmentID
        }
      })
    }
  }

  return (
    <div>
      <Input
        type="text"
        value={inputRelease || ''}
        onChange={handleReleaseChange}
        onBlur={handleReleaseBlur}
        placeholder="Add a release"
        onFocus={() => {
          if (inputRelease === 'Add a release') {
            setInputRelease(null)
          }
        }}
      />
    </div>
  )
}
